<template>
  <div class="confirm-resume-popup">
    <div class="header">
      <div class="title ellipsis">
        {{ popupData.title ? popupData.title : '' }}
      </div>
    </div>

    <div class="confirm-resume-container">
      <div class="section">
        <div class="container">
          <div class="title-container no-margin">
            <p class="title">
              {{ popupData.content ? popupData.content : '' }}
              <br />
              {{ popupData.company ? popupData.company + '.' : '' }}
            </p>
          </div>
        </div>
        <div
          class="container center"
          :class="{
            extendButtons: popupData.config && popupData.config.extendButton,
          }"
        >
          <div class="main-button button-cancel" @click="popupResolve(false)">
            <div class="text">{{ popupData.cancel || $t('words.cancel') }}</div>
          </div>
          <div class="main-button button-create" :class="{ delete: popupData.delete }" @click="popupResolve(true)">
            <div class="text">
              {{ popupData.confirm || $t('words.confirm') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConfirmPopup',
  computed: {
    ...mapGetters(['popupResolve', 'popupReject', 'popupData', 'user']),
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/inputs.scss';
@use '@/styles/buttons.scss';
@use '@/styles/responsive/popup.scss';

.confirm-resume-popup {
  box-sizing: border-box;
  max-width: 513px;

  .header {
    width: 100%;
    border-bottom: 1px solid colors.$light-blue-color;
    padding-bottom: 22px;
    .title {
      color: colors.$light-blue-color;
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .confirm-resume-container {
    display: flex;
    .section {
      display: flex;
      flex-direction: column;
      width: 100%;
      .container {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        margin-top: 22px;
        &.center {
          flex-direction: row;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          padding: 0 30px;
          margin: 0 0 6px 0;

          .button-cancel {
            margin-right: 22px;
          }

          .main-button {
            margin-top: 30px;
          }
          &.extendButtons {
            .main-button {
              width: 176px;
            }
          }
        }

        .title-container {
          width: 100%;
          .title {
            color: #262626;
            font-size: 16px;
            word-wrap: break-word;
          }
        }
      }
      .field {
        .title {
          height: 19px;
          color: #939292;
          font-size: 16px;
          width: 100%;
        }
      }
    }
  }
}
</style>
